// @flow

import React from "react";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import SortableItem from "./SortableItem";
import { SortableList as StyledSortableList } from "./styles";

type Props = {
  right: boolean,
  items: Array<number>,
  deleteTile: Function,
  editTile: Function,
};

const SortableList = ({ items, right, deleteTile, editTile }: Props) => {
  return (
    <SortableContext items={items} strategy={verticalListSortingStrategy}>
      <StyledSortableList>
        {(items || []).map((value) => (
          <SortableItem
            right={right}
            key={`item-${value}`}
            id={value}
            deleteTile={deleteTile}
            editTile={editTile}
          />
        ))}
      </StyledSortableList>
    </SortableContext>
  );
};

export default SortableList;
